module.exports = __webpack_public_path__ + "img/55.bf01c6ff.jpg";